import { useQuery } from '@apollo/client';
import { useAuthInfo } from '@bfa/nextjs-common/contexts';

import {
  GQLLayoutContent,
  GQLMyData,
  GQLQuery,
} from '../../../../../gql.generated';
import GET_TERMS from '../../../grahpql/queries/GET_TERMS';

interface ExtendedLayout extends GQLLayoutContent {
  giftingTerms: GQLLayoutContent['vcmsAsset'];
  programPagesLinks: GQLLayoutContent['vcmsAsset'];
}

interface ExtendedMyData extends GQLMyData {
  layout: ExtendedLayout;
}

export interface ExtendedGQLQuery extends GQLQuery {
  me: ExtendedMyData;
}

const useGetTerms = () => {
  const { authInfo } = useAuthInfo();
  const { data, loading, error } = useQuery<ExtendedGQLQuery>(GET_TERMS, {
    variables: {
      isLoggedIn: authInfo?.userId !== undefined,
    },
  });

  return {
    loading,
    error,
    navBar: data?.me?.layout?.navigation,
    userId: data?.me?.details?.id,
    giftingTerms: data?.me?.layout?.giftingTerms?.value || '',
  };
};

export default useGetTerms;
